if (!customElements.get('noyoco-season-films')) {
  customElements.define('noyoco-season-films', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('.season-films__slide')];
      if (!this.slides.length) return;
      this.index = 0;
      this.muted = true;
      this.inView = false;
      this.mobile = matchMedia('(max-width:768px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
      this.playButton = this.querySelector('[data-play]');
      this.soundButton = this.querySelector('[data-sound]');
      this.fr = this.dataset.fr === 'true';
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        video.muted = true;
        video.defaultMuted = true;
        video.addEventListener('playing', () => { slide.setAttribute('data-loaded', ''); this.sync(); }, {signal});
        video.addEventListener('loadeddata', () => slide.setAttribute('data-loaded', ''), {signal});
        video.addEventListener('pause', () => this.sync(), {signal});
        video.addEventListener('volumechange', () => this.sync(), {signal});
        video.addEventListener('ended', () => {
          if (i !== this.index || this.userPaused) return;
          if (this.slides.length > 1) this.activate((i + 1) % this.slides.length, false);
          else { this.userPaused = true; this.sync(); }
        }, {signal});
        video.addEventListener('error', () => {
          slide.removeAttribute('data-loaded');
          if (i === this.index) {
            this.userPaused = true;
            this.querySelector('.season-films__status').textContent = this.fr ? 'Le film ne peut pas être chargé. Vous pouvez découvrir le lookbook.' : 'The film could not load. You can still explore the lookbook.';
            this.sync();
          }
        }, {signal});
      });
      this.playButton.addEventListener('click', () => {
        const v = this.video();
        this.userPaused = !v.paused;
        if (this.userPaused) v.pause();
        else { if (v.ended) v.currentTime = 0; this.play(); }
        this.sync();
      }, {signal});
      this.soundButton.addEventListener('click', () => {
        this.muted = !this.muted;
        this.video().muted = this.muted;
        this.sync();
      }, {signal});
      this.querySelectorAll('[data-film-index]').forEach(button => {
        button.addEventListener('click', () => this.activate(Number(button.dataset.filmIndex), true), {signal});
      });
      this.onVisibility = () => {
        if (document.hidden) this.video().pause(); else this.play();
      };
      document.addEventListener('visibilitychange', this.onVisibility, {signal});
      window.addEventListener('pageshow', this.onVisibility, {signal});
      this.mobile.addEventListener('change', () => {
        this.ensureSource(this.slides[this.index]); this.play();
      }, {signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.userPaused = true; this.video().pause(); this.sync(); }
      }, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.play(); else this.video().pause();
      }, {threshold:.1});
      this.observer.observe(this.querySelector('.season-films__stage'));
      this.querySelector('.season-films__controls').hidden = false;
      const navigation = this.querySelector('.season-films__navigation');
      if (navigation) navigation.hidden = false;
      this.ensureSource(this.slides[0]);
      this.sync();
    }
    video() { return this.slides[this.index].querySelector('video'); }
    ensureSource(slide) {
      const v = slide.querySelector('video');
      const src = this.mobile.matches ? slide.dataset.mobile : slide.dataset.desktop;
      if (src && v.getAttribute('src') !== src) {
        v.pause(); slide.removeAttribute('data-loaded');
        v.src = src; v.preload = 'metadata'; v.load();
      }
    }
    play() {
      if (this.userPaused || !this.inView || document.hidden) return;
      this.ensureSource(this.slides[this.index]);
      const v = this.video();
      v.muted = this.muted || this.slides[this.index].dataset.audio !== 'true';
      const attempt = v.play();
      if (attempt) attempt.catch(error => {
        if (error.name === 'NotAllowedError') { this.userPaused = true; this.sync(); }
      });
    }
    activate(index, manual) {
      if (index === this.index) return;
      const old = this.video(); old.pause(); old.muted = true;
      this.index = index;
      this.slides.forEach((s, i) => { s.classList.toggle('is-active', i === index); s.setAttribute('aria-hidden', String(i !== index)); });
      const slide = this.slides[index];
      this.ensureSource(slide);
      const v = this.video();
      if (v.readyState > 0) v.currentTime = 0;
      v.muted = this.muted || slide.dataset.audio !== 'true';
      this.querySelector('h1').textContent = slide.dataset.title;
      this.querySelector('.season-films__eyebrow').textContent = slide.dataset.eyebrow;
      if (this.dataset.lookbook !== 'true') this.querySelector('.season-films__cta').href = slide.dataset.href;
      this.querySelectorAll('[data-film-index]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.filmIndex) === index)));
      if (manual) this.querySelector('.season-films__status').textContent = slide.dataset.title;
      this.sync(); this.play();
    }
    sync() {
      const v = this.video();
      const playing = !v.paused && !v.ended;
      const audio = this.slides[this.index].dataset.audio === 'true';
      this.toggleAttribute('data-playing', playing);
      this.toggleAttribute('data-audible', !v.muted && audio);
      this.playButton.setAttribute('aria-label', this.fr ? (playing ? 'Mettre le film en pause' : 'Lire le film') : (playing ? 'Pause film' : 'Play film'));
      this.soundButton.disabled = !audio;
      this.soundButton.setAttribute('aria-pressed', String(!v.muted && audio));
      this.soundButton.setAttribute('aria-label', !audio ? (this.fr ? 'Ce film est sans piste audio' : 'This film has no audio track') : (this.fr ? (v.muted ? 'Activer le son' : 'Couper le son') : (v.muted ? 'Turn sound on' : 'Mute sound')));
    }
    disconnectedCallback() {
      this.slides?.forEach(s => s.querySelector('video').pause());
      this.abort?.abort(); this.observer?.disconnect(); this.initialized = false;
    }
  });
}
